<template>
    <v-card hover class="ma-0 pa-0">
        <v-card-title style="background-color:#4E87DD; color:#FFFFFF; height:70px;">
            <v-row no-gutters>
                <v-col class="pt-1 pl-4 text-h5 font-weight-bold">비밀번호 변경</v-col>
            </v-row>
        </v-card-title>

        <v-card-text class="mt-3 pb-0 pl-7 pr-7 pt-3">
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">아이디</v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-4">
                    <v-text-field outlined hide-details readonly placeholder="아이디" v-model="userId" style="background-color: #dedede">
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">현재 비밀번호<span style="color:red; padding-left:5px;">*</span></v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-4">
                    <v-text-field outlined hide-details :error="formStatus['currentPassword'].err" type="password" placeholder="현재 비밀번호를 입력해 주세요" v-model="currentPassword"
                                  @keyup="checkChanged('currentPassword')" @change="checkChanged('currentPassword', true)">
                        <template v-slot:append v-if="formStatus['currentPassword'].err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ formStatus['currentPassword'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">새 비밀번호<span style="color:red; padding-left:5px;">*</span></v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-4">
                    <v-text-field outlined hide-details :error="formStatus['newPassword'].err" type="password" placeholder="새 비밀번호를 입력해 주세요" v-model="newPassword"
                                  @keyup="checkChanged('newPassword')" @change="checkChanged('newPassword', true)">
                        <template v-slot:append v-if="formStatus['newPassword'].err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ formStatus['newPassword'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">비밀번호 확인<span style="color:red; padding-left:5px;">*</span></v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-0">
                    <v-text-field outlined hide-details :error="formStatus['newPasswordConfirm'].err" type="password" placeholder="비밀번호를 다시 입력해 주세요" v-model="newPasswordConfirm"
                                  @keyup="checkChanged('newPasswordConfirm')" @change="checkChanged('newPasswordConfirm', true)">
                        <template v-slot:append v-if="formStatus['newPasswordConfirm'].err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ formStatus['newPasswordConfirm'].err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0">
            <v-row no-gutters>
                <v-col cols="12" class="pr-5 pb-6 pt-5 text-right">
                    <v-btn class="ma-2" width="130px" color="primary" text v-on:click="close()"><span style="color:#555555; font-size:1.4em;">취소</span></v-btn>
                    <v-btn class="ma-2 white--text" width="130px" color="#4573D5" large v-on:click="changePassword()" :disabled="!isFormValid"><span style="font-size:1.4em;">변경</span></v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import {passwordValidator} from '@/utils/passwordValidator'

export default {
    name: 'PopupPasswordChange',
    props: {
        userId: {
            type: String,
            required: true
        }
    },
    data: () => ({
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
        formStatus: {
            'currentPassword': {
                err: false,
                err_msg: '',
            },
            'newPassword': {
                err: false,
                err_msg: '',
            },
            'newPasswordConfirm': {
                err: false,
                err_msg: '',
            }
        }
    }),
    computed: {
        isFormValid() {
            return this.currentPassword && this.newPassword && this.newPasswordConfirm &&
                   !this.formStatus.currentPassword.err && !this.formStatus.newPassword.err && !this.formStatus.newPasswordConfirm.err
        },
        formData() {
            return {
                currentPassword: this.currentPassword,
                newPassword: this.newPassword,
                newPasswordConfirm: this.newPasswordConfirm
            }
        }
    },
    methods: {
        changePassword() {
            if (passwordValidator.validateForm(this.formData, this.formStatus)) {
                this.$store.dispatch('admin/changePassword', {
                    param: {
                        current_password: this.currentPassword,
                        new_password: this.newPassword,
                        new_password_confirm: this.newPasswordConfirm
                    },
                    scb: (va) => {
                        va.$store.dispatch('openAlert', {
                            message: `비밀번호가 변경되었습니다.<br />새로운 비밀번호로 다시 로그인해주시기 바랍니다.`,
                            closeCb: () => {
                                va.$emit('close')
                                va.$store.dispatch('login/LOGOUT', {serverFlag: true}).then(() => {
                                    va.$router.push('/login')
                                })
                            }
                        })

                    }, fcb: (err, va) => {
                        if (va.$noSessionProc(err)) {
                            console.log('authentication check failed')
                        } else if (err !== '') {
                            va.$store.dispatch('openAlert', {message: `비밀번호 변경에 실패하였습니다<br />${err}`})
                        }
                    },
                    va: this
                })
            }
        },
        close() {
            this.$emit('close')
        },
        checkChanged(t, focusOutFlag) {
            if (this.formStatus[t] && (this.formStatus[t].err || focusOutFlag)) {
                passwordValidator.validateForm(this.formData, this.formStatus, t)
            }
            if (t === 'newPassword' && this.newPasswordConfirm) {
                passwordValidator.validateForm(this.formData, this.formStatus, 'newPasswordConfirm')
            }
        }
    }
}
</script>